module.exports = __webpack_public_path__ + "img/config_smartbook.a2189f15.png";